var map = {
	"./icon-ai.png": "79cd",
	"./icon-br.png": "41ae",
	"./icon-cron.png": "b2a6",
	"./icon-fp.png": "6676",
	"./icon-hx.png": "e687",
	"./icon-jm.png": "a959",
	"./icon-res.png": "f48c",
	"./icon-school.png": "afce",
	"./icon-vip.png": "1d40",
	"./icon-visit.png": "6d35",
	"./icon-zb.png": "0c28"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd15";